// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.wbm-chlorides-report-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 9pt;
}
.wbm-chlorides-report-table .label-column {
  width: 40%;
}
.wbm-chlorides-report-table .value-column {
  width: 10%;
}
.wbm-chlorides-report-table th,
.wbm-chlorides-report-table td {
  padding: 3px 4px;
  border: 1px solid #20252b;
  vertical-align: middle;
}
.wbm-chlorides-report-table thead th {
  background: #ffffe5;
  color: #20252b;
  font-weight: 400;
  text-align: center;
}
.wbm-chlorides-report-table tbody th {
  width: 40%;
  background: #fff;
  text-align: left;
  white-space: nowrap;
}
.wbm-chlorides-report-table tbody td {
  width: 10%;
  background: #fff;
  text-align: center;
  white-space: nowrap;
}

.empty-state {
  margin: 4px 0;
  color: #69747d;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-request-report/job-request-report-tests/wbm-chlorides-test-report.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AACF;AACE;EACE,UAAA;AACJ;AAEE;EACE,UAAA;AAAJ;AAGE;;EAEE,gBAAA;EACA,yBAAA;EACA,sBAAA;AADJ;AAIE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAFJ;AAKE;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAHJ;AAME;EACE,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;AALF","sourcesContent":[":host {\n  display: block;\n}\n\n.wbm-chlorides-report-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 9pt;\n\n  .label-column {\n    width: 40%;\n  }\n\n  .value-column {\n    width: 10%;\n  }\n\n  th,\n  td {\n    padding: 3px 4px;\n    border: 1px solid #20252b;\n    vertical-align: middle;\n  }\n\n  thead th {\n    background: #ffffe5;\n    color: #20252b;\n    font-weight: 400;\n    text-align: center;\n  }\n\n  tbody th {\n    width: 40%;\n    background: #fff;\n    text-align: left;\n    white-space: nowrap;\n  }\n\n  tbody td {\n    width: 10%;\n    background: #fff;\n    text-align: center;\n    white-space: nowrap;\n  }\n}\n\n.empty-state {\n  margin: 4px 0;\n  color: #69747d;\n  font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
